import React from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import { Alert, Box, Grid, Typography } from '@mui/material'

import { ADMIN_ROLES } from '../../../../core/constants'
import { FileUploaderInput } from '../../../../ui'
import { useCombos } from '../../../combos'
import { COMPANY_FORM_CONFIG } from '../../constants'
import { useCompanyProfileContext } from '../../contexts'
import { getEnv } from '../../../../config/env'

const REACT_APP_WP_CONTENT_CREATOR_URL = getEnv('REACT_APP_WP_CONTENT_CREATOR_URL')

export const CompanyDocuments = ({ isPrimaryCompany = true }) => {
  const { company, formState, changeFormState } = useCompanyProfileContext()
  const intl = useIntl()
  const combos = useCombos([])
  const global = useSelector((state) => state.global)
  const isAdmin = ADMIN_ROLES[global.role]
  const inputProps = { formState, onChange: changeFormState, combos, intl }

  const primaryCompanyDocs = [
    {
      key: 'IBAN_CERTIFICADO',
      show: formState.grabadora && global.role !== 'administrador_prescriptor',
    },
    {
      key: 'NIF_EMPRESA',
      show: formState.captadora,
    },
    {
      key: 'PERSONA_FISICA',
      show: formState.captadora && global.role !== 'administrador_prescriptor',
    },
    {
      key:
        global.role === 'administrador_prescriptor' || formState.prescriptor
          ? 'MODELO_036'
          : 'REGISTRO_INDUSTRIAL',
      show: true,
    },
    {
      key: 'FORMULARIO_RGPD',
      show: formState.captadora,
      readOnly: true,
      extraContent: (
        <Box display="flex" flexDirection="column" gap={1} mt={1}>
          {!formState.formulario_rgpd && (
            <Alert severity="error">
              {intl.formatMessage({ id: 'pages.profile.company.rgpdMissing' })}
            </Alert>
          )}

          {/* Enlace/Botón de redirección hacia el cuestionario RGPD en WordPress */}
          <Box mt={1}>
            <a
              href={`${REACT_APP_WP_CONTENT_CREATOR_URL}/cuestionario-privacidad-evaluacion-de-proveedores/?uuid=${company.uuid_rgpd || company.id || global.empresa_id}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: '#004a6b',
                fontWeight: '600',
                fontSize: '0.875rem',
                textDecoration: 'underline',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '4px',
                cursor: 'pointer',
              }}
            >
              {intl.formatMessage({
                id: formState.formulario_rgpd
                  ? 'pages.adhesionOp.rgpdUpdateLink'
                  : 'pages.adhesionOp.rgpdFillLink',
              })}
            </a>
          </Box>
        </Box>
      ),
    },
  ]

  return (
    <Box>
      <Typography color="primary" variant={'h6'}>
        {'Documentos de la Empresa'}
      </Typography>
      <Box mt={2}>
        <Grid container spacing={3}>
          {isPrimaryCompany ? (
            primaryCompanyDocs
              .filter((doc) => doc.show)
              .map((doc) => (
                <Grid item xs={12} sm={6} key={doc.key}>
                  <FileUploaderInput
                    {...{
                      ...COMPANY_FORM_CONFIG(inputProps)[doc.key],
                      readOnly: doc.readOnly || !isAdmin,
                    }}
                  />
                  {doc.extraContent}
                </Grid>
              ))
          ) : (
            <Grid item xs={12} sm={6}>
              <FileUploaderInput
                {...{
                  ...COMPANY_FORM_CONFIG(inputProps).CERTIFICADO_BANCARIO_IBAN_SWIFT,
                  readOnly: !isAdmin,
                }}
              />
            </Grid>
          )}
        </Grid>
      </Box>
    </Box>
  )
}
